module.exports = __webpack_public_path__ + "img/直播回放.cfcbe73f.png";